<template>
  <div class="message-board"> 
    <el-button
      @click="showBoard"
      v-show="false"
    ></el-button>
    <el-dialog
      :title="$t('messageBoard.OnlineMessage')"
      :visible.sync="dialogForm"
      class="form-dialog"
      :width="clientWidth < 992?'100%':'400px'"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item :label="$t('messageBoard.BusinessType')" prop="reporterType">
          <el-select v-model="ruleForm.reporterType"  style="width:100%;" :placeholder="$t('messageBoard.SelectBusinessType')">
            <el-option :label="language=='cn' ? item.dictLabel : language=='en'?item.cssClass : item.remark "  :value="item.dictValue" v-for="(item,index) in bussinessype" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('messageBoard.name')" prop="reporter">
          <el-input v-model="ruleForm.reporter"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageBoard.phone')" prop="reporterMobile">
          <el-input v-model="ruleForm.reporterMobile"></el-input>
        </el-form-item>

        <el-form-item :label="$t('messageBoard.email')" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item :label="$t('messageBoard.message')" prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>

        <div class="textc">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >{{$t("messageBoard.SubmitMessage")}}</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { by_typename } from "../api/news"
import { submitReporter  } from "../api/talentRecruitment"
import { mapGetters } from "vuex";
export default {
  name: "BoardForm",
  data() {
    return {
      dialogForm:false,
      bussinessype:[],
      ruleForm: {
        sayType :"2",       //类型：1投诉举报、2联系我们、3简历投递
        reporterType : '',   //举报类型编号
        reporter : '',       //信息提交人姓名
        reporterMobile : '',  //联系方式
        email : '',  //邮箱
        remark  : '',         //问题描述
      },
      rules:{
        reporterType: [
          {
            required: true,
            message: this.$t("messageBoard.rules.SelectBusinessType"),
            trigger: "change"
          }
        ],
        reporter: [
          {
            required: true,
            message: this.$t("messageBoard.rules.EnterName"),
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: this.$t("messageBoard.rules.NameLength"),
            trigger: "blur"
          }
        ],
        reporterMobile: [
          {
            required: true,
            // pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: this.$t("messageBoard.rules.ContactNumber"),
            trigger: "blur"
          }
        ],
        // email: [
        //   {
        //     required: true,
        //     message: this.$t("messageBoard.rules.EmailAddress"),
        //     trigger: "blur"
        //   },
        //   {
        //     type: "email",
        //     message: this.$t("messageBoard.rules.CorrectEmailAddress"),
        //     trigger: "blur"
        //   }
        // ],
        remark: [
          {
            required: true,
            message: this.$t("messageBoard.rules.messageContent"),
            trigger: "blur"
          }
        ],
      }
    };
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
    // 业务类型
    by_typename(this.language,{dictType:'dqgx_bussiness_type'}).then(res=>{
      this.bussinessype= res.data;
    });
  },
  computed: {
    ...mapGetters(['language']),
    clientWidth(){
      return document.body.clientWidth
    }
    
  },
  methods: {
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          submitReporter(this.language,this.ruleForm).then(res =>{
            this.dialogForm=false;
            this.$refs[ruleForm].resetFields();
            this.$message.success(res.msg);
          })
        } else {
          return false;
        }
      });
    },
    showBoard(){
      this.dialogForm=true;
    }
  },

};
</script>

<style lang="scss" scoped>
.message-board .el-select {
  display: block;
}

</style>
